"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_MAP_FOR_ADDRESS = exports.USE_GOOGLE_PLACES_FOR_ADDRESS = exports.UNUSED_FIELDS_IN_STORE_UPDATE = exports.HIDE_CITY_STATE_COUNTRY_FIELDS = void 0;
var USE_GOOGLE_PLACES_FOR_ADDRESS = process.env.REACT_APP_USE_GOOGLE_PLACES_FOR_ADDRESS || false;
exports.USE_GOOGLE_PLACES_FOR_ADDRESS = USE_GOOGLE_PLACES_FOR_ADDRESS;
var HIDE_CITY_STATE_COUNTRY_FIELDS = process.env.REACT_APP_HIDE_CITY_STATE_COUNTRY_FIELDS || false;
exports.HIDE_CITY_STATE_COUNTRY_FIELDS = HIDE_CITY_STATE_COUNTRY_FIELDS;
var USE_MAP_FOR_ADDRESS = process.env.REACT_APP_USE_MAP_FOR_ADDRESS || false;
exports.USE_MAP_FOR_ADDRESS = USE_MAP_FOR_ADDRESS;
var UNUSED_FIELDS_IN_STORE_UPDATE = process.env.REACT_APP_UNUSED_FIELDS_IN_STORE_UPDATE || "";
exports.UNUSED_FIELDS_IN_STORE_UPDATE = UNUSED_FIELDS_IN_STORE_UPDATE;